import { Component, NgZone, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { RedirectHelper } from '../../../page-modules/resource/store/editor/content/helpers/redirect.helper';
import { MagicLinkResponseType } from '../../models/login-response.model';
import { TriggerMagicLinkLogin } from '../../store/user-auth.actions';
import { UserAuthState } from '../../store/user-auth.state';

@Component({
  templateUrl: './magic-link-signin.component.html',
})
export class MagicLinkSigninComponent implements OnInit {
  verifying = true;
  errorType: MagicLinkResponseType | null = null;

  constructor(
    private store: Store,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private ngZone: NgZone,
  ) {}

  ngOnInit() {
    const token = this.activatedRoute.snapshot.queryParamMap.get('token');
    if (!token) {
      this.verifying = false;
      this.errorType = 'TOKEN_NOT_FOUND';
      return;
    }

    // On success, TriggerMagicLinkLogin's handler redirects the user home; on failure it
    // patches `magicLinkLoginError`, which we read once the dispatch completes.
    this.store.dispatch(new TriggerMagicLinkLogin(token)).subscribe(() => {
      const errorType = this.store.selectSnapshot(UserAuthState.magicLinkLoginError);
      if (errorType) {
        this.verifying = false;
        this.errorType = errorType;
      }
    });
  }

  get titleKey(): string {
    if (this.verifying) {
      return 'translations.public.message.signingInMagicLink';
    }
    switch (this.errorType) {
      case 'TOKEN_EXPIRED':
        return 'translations.errors.errorMagicLinkExpired';
      case 'TOKEN_ALREADY_USED':
        return 'translations.errors.errorMagicLinkUsed';
      case 'ACCOUNT_NOT_VERIFIED':
        return 'translations.errors.errorMagicLinkNotVerified';
      case 'ORG_INACTIVE':
        return 'translations.errors.errorMagicLinkOrgInactive';
      case 'TOKEN_NOT_FOUND':
      case 'ORG_MISMATCH':
        return 'translations.errors.errorMagicLinkInvalid';
      default:
        return 'translations.errors.errorMagicLinkGeneric';
    }
  }

  get buttonNameKey(): string {
    return this.errorType === 'ACCOUNT_NOT_VERIFIED'
      ? 'translations.public.button.verifyYourEmail'
      : 'translations.public.button.backToSignIn';
  }

  onButtonClick() {
    const path = this.errorType === 'ACCOUNT_NOT_VERIFIED' ? '/unverified-email' : '/signin';
    RedirectHelper.redirectByUrl(this.ngZone, this.router, this.activatedRoute, path);
  }
}
